import { v4 as uuidv4 } from 'uuid';
import { deepClone } from "@/common/utils";

export const site = {
  state: {
    sites: {} /*
        uuud: {
          uuid: null,
          name: null,
          description: null,
          lat: null,
          lng: null,
          last_sync_at
        }
    */
  },
  mutations: {
    insertSite(state, newSite) {
      state.sites[newSite.uuid] = newSite;
    },

    updateSite(state, payload) {
      const siteUUID = payload.uuid;
      if (state.sites[siteUUID]) {
        state.sites[siteUUID] = payload;
      }
    },

    removeSite(state, site_uuid) {
      delete state.sites[site_uuid]
    }

  },
  actions: {
    addSite({ commit }, payload) {
      console.log("Inside site.mondule.js, addSite(), payload ==> ", payload);
      const new_site = payload;
      if (!new_site.uuid) {
        const newUUID = uuidv4();
        new_site.uuid = newUUID;
        console.log("Inside site.mondule.js, addSite(), newUUID ==> ", newUUID);
        new_site.created_at = new Date().toISOString();
        new_site.updated_at = new Date().toISOString();  
      }
      commit("insertSite", new_site);
      return new_site.uuid;
    },

    modifySite({ commit }, payload) {
      console.log("Inside site.mondule.js, modifySite(), payload ==> ", payload);
      const site = deepClone(payload); // deepClone to avoid mutation problem
      site.updated_at = new Date().toISOString();
      commit("updateSite", site);
    },

    timestampSiteSync({ commit, getters }, site_uuid) {
      const site = getters.getSite(site_uuid);
      site.sync_on = new Date().toISOString();
      commit("updateSite", site);
    },

    deleteSite({ commit, dispatch }, site_uuid) {
      dispatch('deleteAssetsBySite', site_uuid);
      dispatch('deleteEmosByOwner', site_uuid);
      dispatch('deleteLocationsBySite', site_uuid);
      dispatch('deleteMetersBySite', site_uuid);
      dispatch('deleteImagesByOwner', site_uuid);
      dispatch('deleteEmosByOwner', site_uuid);
      dispatch('deleteNotesBySite', site_uuid);
      commit("removeSite", site_uuid);      
    },

    deleteAllSites({ getters, dispatch }) {
      getters.allSites.forEach(function(site) {
        dispatch("deleteSite", site.uuid);
      });
    }
  },
  getters: {
    allSites(state) {
      return Object.values(state.sites);
    },
    getSite(state) {
      return function(uuid) {
        const site = state.sites[uuid]
        return site ? deepClone(site) : null
      }
    },
    siteName(state) {
      return function(uuid) {
        return state.sites[uuid].name
      }
    },
    siteDescription(state) {
      return function(uuid) {
        return state.sites[uuid].description
      }
    },
    siteLngLat(state) {
      return function(uuid) {
        const site = state.sites[uuid];
        return {
          long: site.long,
          lat: site.lat
        }
      }
    },
    getSiteByName(state, getters) {
      return function(givenName) {
        console.log("INside site.module.js, getSiteByName, givenName ==> ", givenName);
        const site = getters.allSites.find(function(site) {
          console.log("INside site.module.js, getSiteByName, site ==> ", site);
          console.log("INside site.module.js, getSiteByName, site.name ==> ", site.name);
          return (site.name == givenName);
        })
        return site ? deepClone(site) : null;
      }
    }
  }
}